import React, { useEffect } from "react";
import "../reservas/reservas-organizer.css";

/* Piezas mínimas del módulo Turnos Beauty (mismas clases que el toast y la confirmación de Canchas). */

export function OrgToast({ message, onClose }) {
  useEffect(() => {
    if (!message) return undefined;
    const t = setTimeout(onClose, 3500);
    return () => clearTimeout(t);
  }, [message, onClose]);

  if (!message) return null;
  return (
    <div className="org-toast" role="alert">
      {message}
    </div>
  );
}

export function ConfirmModal({ title, children, confirmLabel = "Eliminar", busy = false, onConfirm, onCancel }) {
  return (
    <div className="zr-overlay" onMouseDown={onCancel}>
      <div className="zr-modal" role="dialog" aria-label={title} onMouseDown={(e) => e.stopPropagation()}>
        <h3 className="zr-modal__title">{title}</h3>
        <p className="zr-modal__text">{children}</p>
        <div className="zr-modal__actions">
          <button type="button" className="zr-btn zr-btn--ghost" onClick={onCancel} disabled={busy}>Cancelar</button>
          <button type="button" className="zr-btn zr-btn--dark" onClick={onConfirm} disabled={busy}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
